import { render, staticRenderFns } from "./HistoryModifications.vue?vue&type=template&id=79dff09e"
import script from "./HistoryModifications.vue?vue&type=script&lang=js"
export * from "./HistoryModifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports